import React from 'react';
import { Caption } from '@atlaskit/editor-common/ui';
var RenderCaption = function RenderCaption(_ref) {
  var children = _ref.children,
    dataAttributes = _ref.dataAttributes;
  return /*#__PURE__*/React.createElement(Caption, {
    hasContent: true,
    dataAttributes: dataAttributes
  }, children);
};
export default RenderCaption;